interface TranscriptTextProps {
  text: string;
}

const TranscriptText: React.FC<TranscriptTextProps> = ({ text }) => {
  return (
    <div className="max-w-screen-lg opacity-100 text-text-primary">
      <div className="max-w-5xl">
        <p className="text-[20px] text-left font-normal ">{text}</p>
      </div>
    </div>
  );
};

export default TranscriptText;
